import React from 'react';
import {Link} from 'react-router-dom';
import UserMenu from "../UserMenu/UserMenu";

import './SiteNav.css';
import PendingInvitations from "../PendingInvitations/PendingInvitations";

function SiteNav() {
	return (
		<nav className="navbar bg-accent text-accent-content fixed top-0 w-full z-30 site-nav" aria-label="Site nav">
			<div className="navbar-start">
				<Link to="/" className="site-brand">boarded</Link>
			</div>
			<div className="navbar-end gap-2">
				<PendingInvitations />
				<UserMenu />
			</div>
		</nav>
	);
}

export default SiteNav;
